import * as Yup from "yup";

const ForVouResolvers: {[key: string]: Yup.AnySchema} = {
    name: Yup.string().required(),
    phone: Yup.object()
        .shape({
            code: Yup.number().required(),
            number: Yup.string().required()
        })
        .required(),
    email: Yup.string().email().required()
};

export const useForYouFormResolvers = (names: string[]) => {
    const resolvers = names.reduce((acc, name) => {
        const resolver = ForVouResolvers[name];
        if (resolver) {
            return {...acc, [name]: resolver};
        }
        return acc;
    }, {});

    return Yup.object(resolvers);
};
import * as Yup from "yup";

const ForVouResolvers: {[key: string]: Yup.AnySchema} = {
    name: Yup.string().required(),
    phone: Yup.object()
        .shape({
            code: Yup.number().required(),
            number: Yup.string().required()
        })
        .required(),
    email: Yup.string().email().required()
};

export const useForYouFormResolvers = (names: string[]) => {
    const resolvers = names.reduce((acc, name) => {
        const resolver = ForVouResolvers[name];
        if (resolver) {
            return {...acc, [name]: resolver};
        }
        return acc;
    }, {});

    return Yup.object(resolvers);
};
